import React from 'react';

const RecentTracks = ({ track }) => {
  if (!track) return null;

  const isNowPlaying = track['@attr'] && track['@attr'].nowplaying;
  const albumArt = track.image && track.image[track.image.length - 1]['#text'];

  return (
    <div className="recent-track">
      <div className="now-playing">
        {albumArt && <img src={albumArt} alt="Album cover" />}
        <div className="now-playing-text">
          <p>{isNowPlaying ? '— Now Playing' : '— Last Played'}</p>
          <p>{track.name}</p>
          <p>{track.artist['#text']}</p>
        </div>
      </div>
    </div>
  );
};

export default RecentTracks;
